import { Routes } from '@angular/router';
import { MainLayout } from './core/layouts/main-layout/main-layout';
import { authGuard, noAuthGuard } from './features/auth/auth.guard';
import { roleGuard } from './features/auth/role.guard';
import { Login } from './features/auth/login/login';
import { ForgotPassword } from './forgot-password/forgot-password';

export const routes: Routes = [
  {
    path: 'login',
    component: Login,
    canActivate: [noAuthGuard],
  },

  {
    path: 'forgot-password',
    component: ForgotPassword,
    canActivate: [noAuthGuard],
  },

  {
    path: '',
    component: MainLayout,
    canActivate: [authGuard],
    children: [
      // ejemplo en app-routing (o el modulo de backoffice)
      {
        path: '',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () => import('./features/home/home-page/home-page').then((m) => m.HomePage),
      },
      {
        path: 'administradores',
        canActivate: [roleGuard(['admin', 'superadmin'])],
        loadComponent: () =>
          import('./features/administrator/administrators-page/administrators-page').then(
            (m) => m.AdministratorsPage,
          ),
      },
      {
        path: 'usuarios',
        canActivate: [roleGuard(['admin', 'superadmin'])],
        loadComponent: () =>
          import('./features/users/users-page/users-page').then((m) => m.UsersPage),
      },
      {
        path: 'familia',
        // canActivate: [roleGuard(['admin', 'superadmin', 'administrative'])],
        loadComponent: () =>
          import('./features/family/family-page/family-page').then((m) => m.FamilyPage),
      },
      {
        path: 'vinculos',
        // canActivate: [roleGuard(['admin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/users-ties/users-page/users-ties-page').then((m) => m.UsersTiesPage),
      },
      {
        path: 'validaciones/identidad',
        canActivate: [roleGuard(['admin', 'superadmin', 'administrative'])],
        loadComponent: () => import('./features/validator/validator').then((m) => m.Validator),
      },

      {
        path: 'perfil/datos-personales',
        loadComponent: () =>
          import('./features/profile/profile-personal-data/profile-personal-data').then(
            (m) => m.ProfilePersonalData,
          ),
      },
      {
        path: 'perfil/restablecer-clave',
        loadComponent: () =>
          import('./features/profile/reset-pass/reset-pass').then((m) => m.ResetPass),
      },
      {
        path: 'profesionales',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/professionals/professional-page/professional-page').then(
            (m) => m.ProfessionalPage,
          ),
      },

      {
        path: 'pacientes',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/patient/patients-page/patients-page').then((m) => m.PatientsPage),
      },
      {
        path: 'config/obras-sociales',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/coverage/coverage-page/coverage-page').then((m) => m.CoveragePage),
      },
      {
        path: 'config/planes',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/coverage-plans/coverage-plans-page/coverage-plans-page').then(
            (m) => m.CoveragePlansPage,
          ),
      },
      {
        path: 'config/especialidades',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/specialties/specialties-page/specialties-page').then(
            (m) => m.SpecialtiesPage,
          ),
      },
      {
        path: 'config/subespecialidades',
        // canActivate: [roleGuard(['admin', 'superadmin', 'backoffice', 'profesional', 'paciente'])],
        loadComponent: () =>
          import('./features/subspecialties/subspecialties-page/subspecialties-page').then(
            (m) => m.SubSpecialtiesPage,
          ),
      },
      { path: '**', redirectTo: '' },
    ],
  },
];
